/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type representing a call status.
 */
export enum CallStatus {
    QUEUED = 'queued',
    INITIATED = 'initiated',
    RINGING = 'ringing',
    IN_PROGRESS = 'in-progress',
    COMPLETED = 'completed',
    BUSY = 'busy',
    FAILED = 'failed',
    NO_ANSWER = 'no-answer',
    CANCELED = 'canceled',
    UNKNOWN = 'unknown',
}
